import { userInfoCommitComposable } from '@/composables';
import { Toast } from 'vant';

export default [
  async (to, from, next) => {
    if (!to.query.token) {
      next();
      return;
    }
    console.log('to:', to);
    // 去除授权参数
    const toQuery = JSON.parse(JSON.stringify({ ...to.query }));
    delete toQuery.token;
    next({ name: to.name, query: toQuery, params: to.params, replace: true });
  },
  async (to, from, next) => {
    const userInfo = await userInfoCommitComposable;
    if (to.meta.auth && !userInfo.id) {
      Toast('登录失效，请重新登录');
      return;
    }
    next();
  },
  async (to, from, next) => {
    console.log('beforeEach to:');
    console.log(to);
    next();
  },
];
